export function buildSecureBusinessWriteRequest(action, orgId, payload = {}) {
  return {
    ...payload,
    action,
    orgId,
  };
}
